import { clingo } from "./clingo.js";

export async function importClingo() {
  let x = await clingo.init(location.href + "clingo.wasm");
  window.clingo = clingo;
  return clingo;
}